import React, {useState} from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { editProfile } from "../services/editService";

// Pass a user to the edit profile page.
// Displays the form where the user's data can be edited.
const EditProfileForm = (user) => { 
    const history = useHistory()
    const [updatedUser, setUpdatedUser] = useState('') 
    let[cpassword, csetPassword] = useState('')
    useEffect(() => {
        setUpdatedUser(user.user)
        csetPassword(user.user.password)
    }, [])

    const submitUser = () => {
        const editedUser = {...user.user, ...updatedUser};
        //console.log(editedUser)
        editProfile(editedUser).then(status => history.push('/home'))
                                .catch((e) => {
                                    alert("Issue while editing the data!")
                                    //Redirect to the profile page if there is an issue.
                                    //history.push('/profile')
                                })
    }
    
    return(
        <div className=" container wd-border-form mt-3" style={{background:"border-box"}}>
            <h2>Edit Profile</h2>
            <div className="form-group">
                <div className="p-1">
                    <label htmlFor="name" className="form-label" style={{color:"gray"}}>Name</label>
                    <input className="form-control wd-input p-0" name="name" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))} style={{color:"black"}} defaultValue={user.user.name}>
                    </input>
                </div>
                <div className="p-1">
                    <label htmlFor="email" className="form-label mt-3" style={{color:"gray"}}>Email</label>
                    <input type="email" className="form-control wd-input p-0" name="email" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))}  
                    id="email" aria-describedby="email" style={{color:"black"}} value={user.user.email} disabled>
                    </input>
                </div>

                <div className="wd-border-form p-1">
                    <label htmlFor="userId" className="form-label mt-3" style={{color:"gray"}}>UserId</label>
                    <input className="form-control wd-input p-0" name="userId"  
                    id="userId" aria-describedby="userId" style={{color:"black"}} value={user.user.userId} disabled>
                    </input>
                </div>
                <div className="wd-border-form p-1">
                    <label htmlFor="website" className="form-label mt-3" style={{color:"gray"}}>Password</label>
                    <input type="password" className="form-control wd-input p-0" name="password" onChange={e => setUpdatedUser((value) => ({...value,[e.target.name] : e.target.value}))}  
                    id="password" aria-describedby="website" style={{color:"black"}} name="password">
                    </input>
                </div>
                <div className="wd-border-form p-1">
                    <label htmlFor="website" className="form-label mt-3" style={{color:"gray"}}>Confirm Password</label>
                    <input type="password" className="form-control wd-input p-0" onChange={(event) =>
                        csetPassword(event.target.value)}  id="password" aria-describedby="website" style={{color:"black"}} defaultValue={user.user.password}>
                    </input>
                </div>
                <div className="wd-border-form p-1">
                    {
                        updatedUser.password != cpassword && <label htmlFor="website" className="form-label mt-3" style={{color:"red"}}>Passwords don't match</label>
                    }
                </div>
                <div>
                    {/*<Link to = "/login ">*/}
                        {
                            updatedUser.password == cpassword && <button className="btn btn-primary rounded-pill wd-register-button mt-3" onClick={submitUser}> Edit </button>
                        }
                    {/*</Link>*/}
                        {
                            (updatedUser.password != cpassword) && <button className="btn btn-primary rounded-pill wd-register-button mt-3" disabled> Edit </button>
                        }
                </div>
            </div>
        </div>
    )
}

export default EditProfileForm;